export function ImpactDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.IMPACT)
        .setCustomActions({
            'get': {
                method: 'POST',
                isArray: true
            },
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/impact_dao.js